import { ErrorEntityApi, ErrorEntity } from './entity';

/**
 * Нормализует ErrorEntityApi в ErrorEntity
 * @param raw
 */
export const normalizeErrorEntity = (raw: ErrorEntityApi): ErrorEntity => {
  return {
    message: raw.message || '',
  };
};
